import "./DueDiligenceSupport.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import OurDueDiligenceServices from "./sections/OurDueDiligenceServices";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function DueDiligenceSupportPage() {
  return <div>
      <Header />
      <Overview />
      <OurDueDiligenceServices />
      <Contact />
      <Footer />
    </div>;
}